<header id="main-header">
  <div class="container">
    <div class="row">

      <div class="col-lg-3 col-7 my-auto" [class.opaco-desactivado]="modoLigaApp && !modoExterna"
        [class.bloqueado-sin-opacidad]="modoLigaApp && modoExterna">
        <a [routerLink]="['/home']">
          <img src="/assets/img/sorteo2026/logo.png" alt="Sorteo Anáhuac 2026" class="logo img-fluid" width="260">
        </a>
      </div>

      <div class="col-lg-9 col-5 my-auto ">
        <div class="mobile-nav-trigger" [class.opaco-desactivado]="isBlocked || modoLigaApp">
          <div class="hamburger hamburger--squeeze">
            <div class="hamburger-box">
              <div class="hamburger-inner"></div>
            </div>
          </div>
        </div>
        <nav class="main-nav d-xl-block d-none" style="margin-top: 10px;">
          <ul class="site-navigation ">

            <li *ngIf="!enVentaExterna" [class.opaco-desactivado]="isBlocked || modoLigaApp">
              <a href="{{Urlsitio}}premios-sorteo-anahuac" target="_blank"> Premios
              </a>
            </li>


            <li *ngIf="!enVentaExterna" [class.opaco-desactivado]="isBlocked || modoLigaApp">
              <a href="{{Urlsitio}}/contacto" target="_blank">
                Contacto
              </a>
            </li>

          </ul>
        </nav>


      </div>


    </div>
  </div>


</header>

<section class="sub-menu ">
  <div class="container-fluid">
    <div class="row align-items-center justify-content-between">



      <div class="col-md-12 text-center mx-auto">

        <div class="hero-container">
          <nav class="apple-glass-bar d-flex justify-content-between align-items-center">

            <div class="glass-section text-left">
              <!-- <a href="/inicio" class="glass-btn d-inline-flex align-items-center">
                                <i class="fa fa-caret-left mr-2"></i>
                                <span class="font-weight-bold">Inicio</span>
                            </a> -->
            </div>

            <div class="glass-section text-center border-left border-right">
              <a class="glass-btn d-inline-block">
                <img src="assets/img/sorteo2026/logo-magno.png" alt="Sorteo Anáhuac" height="35">
              </a>
            </div>

            <div class="glass-section text-right">
              <!-- <a href="/login" class="glass-btn d-inline-flex align-items-center justify-content-end">
                                <i class="fa fa-user-circle mr-2" style="font-size: 25px;"></i>
                                <span class="font-weight-bold">Inicio de sesión</span>
                            </a> -->
            </div>

          </nav>
        </div>



      </div>
    </div>
  </div>
</section>


<nav class="hidden-menu mobile-menu" >
  <ul class="mobile-nav" >
    <span class="close d-block d-md-none" (click)="close();">×</span>
    <h3 class="p-0 m-0">
      MENÚ
    </h3>
    <hr class="line p-0 ">

    <li><a href="https://gana.sorteoanahuac.mx/" class="main-nav-link" target="_blank"> Blog</a></li>
    <li><a href="{{Urlsitio}}contacto" class="main-nav-link" target="_blank"> Contacto</a></li>
    <li><a href="{{Urlsitio}}remanentes" class="main-nav-link" target="_blank"> Destino de fondos</a></li>
    <li><a href="{{Urlsitio}}galeria" class="main-nav-link" target="_blank"> Galería</a></li>
    <li><a href="{{Urlsitio}}ganadores-sorteo" class="main-nav-link" target="_blank"> Ganadores Sorteos</a></li>
    <li><a href="{{Urlsitio}}venta-meses-sin-intereses" class="main-nav-link" target="_blank"> Meses sin intereses</a></li>
    <li><a href="{{Urlsitio}}nosotros" class="main-nav-link" target="_blank"> Nosotros</a></li>
    <li><a href="{{Urlsitio}}preguntas-frecuentes" class="main-nav-link" target="_blank"> Preguntas frecuentes</a></li>
    <li><a href="{{Urlsitio}}premios-sorteo-anahuac" class="main-nav-link" target="_blank"> Premios Sorteo Magno</a></li>
    <li><a href="{{Urlsitio}}premios-para-colaboradores" class="main-nav-link" target="_blank"> Premios colaborador Sorteo Magno</a></li>
    <li><a href="{{Urlsitio}}sorteo-oportuno" class="main-nav-link" target="_blank"> Sorteos oportunos</a></li>
    <li><a (click)="close();" class="last-child latido-egr mt.2" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/pagar-boletos-en-linea']">Tus boletos</a></li>


  </ul>
</nav>


<div class="overlay" (click)="close();">

</div>
